import { render, staticRenderFns } from "./stuCenter.vue?vue&type=template&id=217d113d&scoped=true"
import script from "./stuCenter.vue?vue&type=script&lang=js"
export * from "./stuCenter.vue?vue&type=script&lang=js"
import style0 from "./stuCenter.vue?vue&type=style&index=0&id=217d113d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217d113d",
  null
  
)

export default component.exports